(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-countdown"] && !Shopify.designMode) return;
  try {
    class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.timer = this.querySelector('[data-countdown-timer]');
      this.message = this.querySelector('[data-countdown-message]');
      this.notice = this.querySelector('[data-countdown-notice]');
      this.originalMessage ??= this.message.innerHTML;
      this.message.innerHTML = this.originalMessage;
      this.timer.hidden = true;
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-countdown-${unit}]`));
      this.deadline = this.parseDeadline();
      if (this.notice) this.notice.hidden = Number.isFinite(this.deadline);
      if (!Number.isFinite(this.deadline)) return;
      if (this.update()) this.interval = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }

    parseDeadline() {
      const date = this.dataset.endDate.trim();
      const time = this.dataset.endTime.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute] = time.split(':').map(Number);
      const target = Date.UTC(year, month - 1, day, hour, minute);
      const check = new Date(target);
      if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
      try {
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.timezone.trim(),
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        let instant = target;
        for (let attempt = 0; attempt < 4; attempt += 1) {
          const parts = Object.fromEntries(formatter.formatToParts(instant).map(({ type, value }) => [type, value]));
          const local = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
          if (local === target) return instant;
          instant += target - local;
        }
      } catch {
        return NaN;
      }
      return NaN;
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === 0) {
        this.timer.hidden = true;
        if (this.dataset.expiredText.trim()) {
          this.message.textContent = this.dataset.expiredText;
          const label = this.querySelector('[data-countdown-link-label]');
          if (label) label.textContent = this.dataset.expiredText;
        }
        this.stop();
        return false;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.fields.forEach((field, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (field.textContent !== value) field.textContent = value;
      });
      this.timer.hidden = false;
      return true;
    }
  }

  if (!customElements.get('announcement-countdown')) {
    customElements.define('announcement-countdown', AnnouncementCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nco-mini-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nco-mini-reviews')) {
    class NcoMiniReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.nav = this.querySelector('[data-nav]');
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setup();

        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        }, { passive: true });
        this.track.addEventListener('pointerdown', () => this.stop());

        this.onBlockSelect = (e) => {
          const slide = e.target.closest?.('.nco-mrs__slide');
          if (slide && this.contains(slide)) { this.stop(); this.go(this.slides.indexOf(slide)); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.addEventListener('pointerenter', () => this.pause());
        this.addEventListener('pointerleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      setup() {
        this.slides = [...this.track.querySelectorAll(':scope > .nco-mrs__slide')];
        const n = this.slides.length;
        this.dotsWrap.innerHTML = '';
        this.nav.hidden = n < 2;
        this.slides.forEach((slide, i) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'avis');
          slide.setAttribute('aria-label', `${i + 1} sur ${n}`);
          if (n < 2) return;
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nco-mrs__dot';
          dot.setAttribute('aria-label', `Afficher l’avis ${i + 1}`);
          dot.addEventListener('click', () => this.go(i, true));
          this.dotsWrap.appendChild(dot);
        });
        this.dots = [...this.dotsWrap.children];
        this.style.setProperty('--nco-mrs-dots-w', n > 1 ? `${n * 11 + 20}px` : '0px');
        this.style.setProperty('--nco-mrs-nav-w', n > 1 ? '84px' : '0px');
        this.update();
      }

      go(i, user = false) {
        const n = this.slides.length;
        if (!n) return;
        if (user) this.stop();
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
        this.update();
      }

      sync() {
        const w = this.track.clientWidth || 1;
        const i = Math.round(this.track.scrollLeft / w);
        if (i !== this.index && this.slides[i]) { this.index = i; this.update(); }
      }

      update() {
        const slide = this.slides[this.index];
        if (!slide) return;
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
        this.slides.forEach((s, k) => s.toggleAttribute('inert', k !== this.index));
      }

      play() {
        if (this.dataset.autoplay !== 'true' || this.reduced || this.stopped || this.slides.length < 2) return;
        this.pause();
        this.timer = setInterval(() => { if (!document.hidden) this.go(this.index + 1); }, parseInt(this.dataset.delay, 10) || 6000);
      }
      pause() { clearInterval(this.timer); }
      stop() { this.stopped = true; this.pause(); }
    }
    customElements.define('nco-mini-reviews', NcoMiniReviews);
  }
  } catch(e) { console.error(e); }
})();

})();
